module.exports = __webpack_public_path__ + "img/icon-payment-sms.9f8d928b.png";